import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
import React from "react";
import { Link } from "react-router-dom";
import { ProgressBar } from "./ProgressBar";
import { cardStyles, colorPallete, textStyles } from "../styles";
import StarIcon from '@material-ui/icons/Star';

export const TestTabletTableCard = props => {
    const cards = cardStyles();
    const textStyle = textStyles();
    const colors = colorPallete();
    const classes = props.className || null;

    const determineCards = props => {
        if (props.useravailable == 1) {
            const path = '/questionScreen';
            return (
                <>
                    <Grid item xs={5}>
                        <Grid container>
                            <div className="width100">
                                <div>
                                    {Number(props.openpercentage) < 100
                                        ? (
                                            <Link
                                                to={{
                                                    pathname: path,
                                                    testYear: props.testYear,
                                                    gameMode: 1
                                                }}
                                            >
                                                <div 
                                                    className="flex-row-between padding-right-8 padding-left-8"
                                                >
                                                    <Grid item xs={12} style={{width: "44%"}}>
                                                        <Typography
                                                            className={clsx(
                                                                textStyle.testCardText,
                                                                colors.lightBlueText
                                                            )}
                                                            style={{fontSize:"1rem !important"}}
                                                        >
                                                            Open Book ({props.openpercentage}%)
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} style={{width: "56%"}}>
                                                        <ProgressBar 
                                                            value={props.openpercentage || 0}
                                                            className="homeProgressFiller" 
                                                        />
                                                    </Grid>
                                                </div>
                                                <Grid item xs={12}>
                                                    <Typography
                                                        className={clsx(
                                                            textStyle.testCardText,
                                                            textStyle.italics,
                                                            colors.lightBlueText
                                                        )}
                                                    >
                                                        {props.openProgress || "BEGIN"}
                                                    </Typography>
                                                </Grid>
                                            </Link>
                                        )
                                        : (
                                            <Link
                                                to={{
                                                    pathname: "/testResultScreen",
                                                    deckID: 0,
                                                    gameMode: 1,
                                                    testYear: props.testYear,
                                                }}
                                            >
                                                <div 
                                                    className="flex-row-between padding-right-8 padding-left-8"
                                                >
                                                    <Grid item xs={12} style={{width: "44%"}}>
                                                        <Typography
                                                            className={clsx(
                                                                textStyle.testCardText,
                                                                colors.lightBlueText
                                                            )}
                                                            style={{fontSize:"1rem !important"}}
                                                        >
                                                            Open Book ({props.openpercentage}%)
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} style={{width: "56%"}}>
                                                        <ProgressBar 
                                                            value={props.openpercentage || 0}
                                                            className="homeProgressFiller" 
                                                        />
                                                    </Grid>
                                                </div>
                                                <Grid item xs={12}>
                                                    <Typography
                                                        className={clsx(
                                                            textStyle.testCardText,
                                                            textStyle.italics,
                                                            colors.lightBlueText
                                                        )}
                                                    >
                                                        {props.openProgress || "BEGIN"}
                                                    </Typography>
                                                </Grid>
                                            </Link>
                                        )
                                    }                          
                                </div>
                            </div>
                        </Grid>
                    </Grid>

                    <div style={{
                        height: "calc(100% - 12px)",
                        width: "2px",
                        margin: "4px 0",
                        background: "#c5c5c5"
                    }}></div>

                    <Grid item xs={5}>
                        <Grid container>
                            <div className="width100">
                                <div>
                                    {Number(props.closedpercentage) < 100
                                        ? (
                                            <Link
                                                to={{
                                                    pathname: path,
                                                    testYear: props.testYear,
                                                    gameMode: 2
                                                }}
                                            >
                                                <div 
                                                    className="flex-row-between padding-right-8 padding-left-8"
                                                >
                                                    <Grid item xs={12} style={{width: "44%"}}>
                                                        <Typography
                                                            className={clsx(
                                                                textStyle.testCardText,
                                                                colors.lightBlueText
                                                            )}
                                                            style={{fontSize:"1rem !important"}}
                                                        >
                                                            Closed Book ({props.closedpercentage}%)
                                                            <span className="show-lg">
                                                                 
                                                            </span>
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} style={{width: "56%"}}>
                                                        <ProgressBar 
                                                            value={props.closedpercentage || 0}
                                                            className="homeProgressFiller" 
                                                        />
                                                    </Grid>
                                                </div>

                                                <Grid item xs={12}>
                                                    <Typography
                                                        className={clsx(
                                                            textStyle.testCardText,
                                                            textStyle.italics,
                                                            colors.lightBlueText
                                                        )}
                                                    >
                                                        {props.closedProgress || "BEGIN"}
                                                    </Typography>
                                                </Grid>
                                            </Link>
                                        )
                                        : (
                                            <Link
                                                to={{
                                                    pathname: "/testResultScreen",
                                                    deckID: 0,
                                                    gameMode: 2,
                                                    testYear: props.testYear,
                                                }}
                                            >
                                                <div 
                                                    className="flex-row-between padding-right-8 padding-left-8"
                                                >
                                                    <Grid item xs={12} style={{width: "44%"}}>
                                                        <Typography
                                                            className={clsx(
                                                                textStyle.testCardText,
                                                                colors.lightBlueText
                                                            )}
                                                            style={{fontSize:"1rem !important"}}
                                                        >
                                                            Closed Book ({props.closedpercentage}%)
                                                            <span className="show-lg">
                                                                 
                                                            </span>
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} style={{width: "56%"}}>
                                                        <ProgressBar 
                                                            value={props.closedpercentage || 0}
                                                            className="homeProgressFiller" 
                                                        />
                                                    </Grid>
                                                </div>

                                                <Grid item xs={12}>
                                                    <Typography
                                                        className={clsx(
                                                            textStyle.testCardText,
                                                            textStyle.italics,
                                                            colors.lightBlueText
                                                        )}
                                                    >
                                                        {props.closedProgress || "BEGIN"}
                                                    </Typography>
                                                </Grid>
                                            </Link>
                                        )
                                    }
                                            
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </>
            );
        } else {
            return (
                <Grid className={cards.testCardTextContainer} item xs={9}>
                    <Typography
                        className={clsx(textStyle.testCardYearText, colors.darkBlueText)}
                    >
                        Purchase this year online
                    </Typography>
                </Grid>
            );
        }
    };

    return (
        <Container
            disableGutters={props.disableGutters || false}
            fixed={props.fixed || false}
            maxWidth={props.maxWidth || "xs"}
            className={clsx(cards.testCardContainer, colors.lightBlueCard, classes)}
        >
            <Grid 
                direction="row" 
                container 
                className={cards.testCardRowContainer} 
                style={{
                    alignItems:"center",
                    justifyContent:"space-between"
                }}
            >
                <Grid className={cards.testCardTextContainer} item xs={1} style={{marginLeft:"8px"}}>
                    <Typography
                        className={clsx(
                            textStyle.testCardYearText,
                            colors.darkBlueText,
                            textStyle.bold
                        )}
                    >
                        {props.testYear || "2020"}
                        <>
                            {
                                props.openProgress.toLowerCase() == 'details' || 
                                props.closedProgress.toLowerCase() == 'details'
                                ? (
                                    <sup style={{position: "relative", top: "-8px"}}>
                                        <StarIcon style={{
                                            fontSize: "0.667em",
                                            color: "#00567a",
                                        }} />
                                    </sup>
                                ) : null
                            }                            
                        </>
                    </Typography>
                </Grid>
                {determineCards(props)}
            </Grid>
        </Container>
    );
};
